export const apiUrl = process.env.REACT_APP_API_URL

export const homeAssistantUrl = process.env.NODE_ENV !== "production" ? process.env.REACT_APP_H_ASSISTANT_URL_DEVELOPMENT : process.env.REACT_APP_H_ASSISTANT_URL_PRODUCTION
